import { Input } from "antd";
import { useEffect, useState, useRef } from "react";
import "./mathCaptcha.css";

const MathCaptcha = ({ onVerify }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("normal"); // "normal" | "success" | "error"
  const inputRef = useRef(null);

  useEffect(() => {
    generateQuestion();
  }, []);

  const generateQuestion = (shouldFocus = false) => {
    // Tăng độ khó nhẹ: 5–25 thay vì 0–9
    const a = Math.floor(Math.random() * 10);
    const b = Math.floor(Math.random() * 10);
    setNum1(a);
    setNum2(b);
    setValue("");
    setStatus("normal");
    onVerify(false);

    if (shouldFocus && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const checkAnswer = () => {
    const numValue = parseInt(value.trim(), 10);
    if (!value.trim() || isNaN(numValue)) {
      return;
    }

    if (numValue === num1 + num2) {
      setStatus("success");
      onVerify(true);
      // Có thể thêm setTimeout để hiện "✓" một lúc rồi ẩn captcha nếu muốn
    } else {
      setStatus("error");
      onVerify(false);
      setTimeout(() => {
        generateQuestion(false); // không focus lại ngay → tránh làm phiền
      }, 600);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      checkAnswer();
    }
  };

  const handleBlur = () => {
    // Chỉ check khi người dùng rời input (tab hoặc click ra ngoài)
    if (value.trim()) {
      checkAnswer();
    }
  };

  const handleChange = (e) => {
    const newVal = e.target.value;
    // Chỉ cho phép số và dấu trừ (phòng trường hợp nhập nhầm)
    if (/^-?\d*$/.test(newVal)) {
      setValue(newVal);
      setStatus("normal"); // reset trạng thái khi đang gõ
    }
  };

  return (
    <div className="math-captcha-wrapper">
      <div className={`captcha-box status-${status}`}>
        <div className="question-part">
          <span className="number">{num1}</span>
          <span className="operator">+</span>
          <span className="number">{num2}</span>
          <span className="equal">=</span>
        </div>

        <Input
          ref={inputRef}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder="?"
          maxLength={4}
          className={`captcha-input status-${status}`}
          status={status === "error" ? "error" : status === "success" ? "success" : ""}
          autoComplete="off"
        />

        {status === "success" && <span className="feedback success">✓ Đúng</span>}
        {status === "error" && <span className="feedback error">Sai — thử lại</span>}
      </div>
    </div>
  );
};

export default MathCaptcha;